/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Version } from "./Version";
export const VersionResponse = core.serialization.object({
    data: Version,
});
